import instance from "../config";

// crear un transporte
const PostTransporte = async (personaId) => {
    try {
        const response = await instance.post('/api/transporte', { personaId });
        return response.data;
    } catch (error) {
        return error.response.data;

    }
}


// metodo para trae todos los transportes 
const getTransporte = async (params) => {

    try {
        const response = await instance.get('/api/transporte',{params});
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
}

export{
    PostTransporte,
    getTransporte,
}